import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Phone } from 'react-feather';
import FeaturesBottom from './FeaturesBottom';
function Terms() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - Kadhr Africa</title>
        <meta name="description" content="Kadhr Africa Terms & Conditions" />
      </Helmet>

      <main className="mtopcon0 ovrflwhdn" id="up">
        <a
          href="https://wa.me/254794072134"
          target="_blank"
          rel="noopener noreferrer"
          className="wappcomms btn-hover float-left"
        >
          <Phone className="text-white" />
        </a>

        <div className="row">
          <div className="col-12 pt-6indx">
            <div className="container txtul">
              <h1 className="mb-0 display-6 font-bold text-center">
                <b>
                  <span className="text-primary">Terms &</span>{' '}
                  <span className="text-dark">Conditions</span>
                </b>
              </h1>
              <p className="text-center mb-4 text-grey">
                Updated April 2026
              </p>

              <h3>1. Introduction</h3>
              <p>
                Welcome to Kadhr Africa. These Terms govern your use of Kadhr’s
                platform, APIs, integrations (including WooCommerce), and
                messaging services (“the Service”). By using the Service, you
                agree to these Terms.
              </p>

              <h3>2. Acceptance of Terms</h3>
              <p>
                By creating an account or using Kadhr, you confirm that you have
                read, understood, and agree to these Terms. If you do not agree,
                you must discontinue use immediately.
              </p>

              <h3>3. User Accounts</h3>
              <p>
                You are responsible for maintaining the confidentiality of your
                account, API keys, and credentials, and for all activities under
                your account.
              </p>

              <h3>4. Intellectual Property</h3>
              <p>
                Kadhr Africa owns all rights to the platform and its technology.
                You may use the Service only as permitted under these Terms.
              </p>

              <h3>5. Data Processing, Messaging & Engagement</h3>

              <h5>5.1 Roles</h5>
              <ul>
                <li>
                  Kadhr acts as a <b>Data Processor</b>.
                </li>
                <li>
                  You (the Vendor) act as the <b>Data Controller</b>.
                </li>
              </ul>

              <h5>5.2 Vendor Responsibilities</h5>
              <p>By using Kadhr, you confirm that:</p>
              <ul>
                <li>
                  You have obtained valid and explicit customer consent before
                  uploading or syncing any data;
                </li>
                <li>
                  Consent covers messaging, personalization, and automated
                  engagement;
                </li>
                <li>
                  You maintain records of consent (source, timing, method);
                </li>
                <li>
                  You comply with the Kenyan Data Protection Act and CA
                  regulations.
                </li>
              </ul>

              <p>
                Kadhr reserves the right to request proof of consent at any time.
              </p>

              <h5>5.3 Use of Data</h5>
              <p>Kadhr processes data only to:</p>
              <ul>
                <li>Send order confirmations and updates;</li>
                <li>Trigger customer retention and engagement;</li>
                <li>Generate insights and analytics;</li>
                <li>Automate customer communication workflows.</li>
              </ul>

              <h5>5.4 Messaging Compliance</h5>
              <ul>
                <li>
                  Messages may only be sent to customers with prior consent or
                  an existing relationship;
                </li>
                <li>
                  Messages must clearly identify the vendor (e.g. “Bio Oils via
                  Kadhr”);
                </li>
                <li>
                  Messages must be factual, non-misleading, and relevant;
                </li>
                <li>
                  Kadhr may limit frequency, block campaigns, or suspend
                  messaging if abuse is detected.
                </li>
              </ul>

              <h5>5.5 Opt-Out</h5>
              <ul>
                <li>
                  Customers can opt out by replying “STOP” or contacting support;
                </li>
                <li>
                  Opted-out users are added to a global suppression list;
                </li>
                <li>
                  Vendors may not bypass or override opt-out mechanisms.
                </li>
              </ul>

              <h5>5.6 Sender ID</h5>
              <ul>
                <li>
                  Messages may be sent using Kadhr’s shared sender ID or a
                  vendor-specific sender ID;
                </li>
                <li>
                  Kadhr may require sender ID registration for higher-volume or
                  branded messaging.
                </li>
              </ul>

              <h5>5.7 Credits & Billing</h5>
              <ul>
                <li>
                  Messaging actions consume credits (e.g. SMS credits);
                </li>
                <li>
                  No processing or messaging occurs without sufficient credits;
                </li>
                <li>
                  Campaigns may stop automatically when credits are exhausted.
                </li>
              </ul>

              <h5>5.8 Abuse Prevention</h5>
              <ul>
                <li>
                  Kadhr actively monitors usage to prevent spam and misuse;
                </li>
                <li>
                  Kadhr may suspend or terminate accounts engaging in abusive or
                  unlawful behavior;
                </li>
                <li>
                  Kadhr may report violations to telecom providers or regulators.
                </li>
              </ul>

              <h5>5.9 External Data Sources</h5>
              <p>
                For data imported via WooCommerce, APIs, spreadsheets, or other
                integrations:
              </p>
              <ul>
                <li>
                  You confirm you have legal authority to use such data;
                </li>
                <li>
                  Kadhr is not responsible for the origin or legality of such
                  data.
                </li>
              </ul>

              <h5>5.10 Indemnification</h5>
              <p>
                You agree to indemnify Kadhr Africa against any claims,
                penalties, or damages arising from:
              </p>
              <ul>
                <li>Failure to obtain valid consent;</li>
                <li>Unlawful messaging or spam complaints;</li>
                <li>Misuse of customer data;</li>
                <li>Regulatory or telecom violations.</li>
              </ul>

              <h3>6. Privacy & Security</h3>
              <p>
                Kadhr implements reasonable technical safeguards including
                encryption, access control, and API security. See our{' '}
                <Link to="/privacy" className="text-primary">
                  Privacy Policy
                </Link>
                .
              </p>

              <h3>7. Prohibited Use</h3>
              <ul>
                <li>Unlawful or fraudulent activity;</li>
                <li>Sending spam or unsolicited communications;</li>
                <li>Uploading data without consent;</li>
                <li>Attempting to disrupt or reverse engineer the platform;</li>
                <li>Using the platform for harmful or abusive purposes.</li>
              </ul>

              <h3>8. Limitation of Liability</h3>
              <p>
                Kadhr Africa shall not be liable for indirect or consequential
                damages including loss of revenue, data, or profits.
              </p>

              <h3>9. Modifications</h3>
              <p>
                Kadhr may update these Terms at any time. Continued use
                constitutes acceptance of changes.
              </p>

              <h3>10. Governing Law</h3>
              <p>
                These Terms are governed by the laws of Kenya. Disputes fall
                under Kenyan jurisdiction.
              </p>
            </div>
          </div>

          <hr />
          <FeaturesBottom/>
        </div>
      </main>
    </>
  );
}

export default Terms;